import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./404Page.css";

const Page404 = () => {
  useEffect(() => {
      // Memastikan halaman tidak dimuat dalam iframe
      if (window.self !== window.top) {
        window.top.location = window.self.location;
      }
  }, []);

  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/"); // Arahkan ke halaman beranda
  };

  return (
    <div className="page-404">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for doesn’t exist or has been moved.</p>
      <button className="go-home-button" onClick={handleGoHome}>
        Go to Home
      </button>
    </div>
  );
};

export default Page404;